
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../httpService/httpService";

export const fetchClientCompletedCampaign = createAsyncThunk(
  "camaign/fetchClientCompletedCampaign",
  async ({page , limit ,id , search}, { rejectWithValue }) => {
    console.log("inside api call for fetching completed campaign") ;
    console.log(search);
    try {
      const token = localStorage.getItem("authToken");
      const response = await axiosInstance.get(
        `/fetch-all-completed-campaigns-client/admin/${id}`,
        {
          params: {
            campaign_name: search.campaign_name,
            start_date: search.createdAtFrom,
            end_date: search.createdAtTo,
            client_name: search.client_fullName,
            region: search.regions,
            city: search.cities,
            count: search.sites,
            page: page,
            limit: limit,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.data || response.status !== 200) {
        throw new Error("Failed to fetch campaigns");
      }

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.message || "An error occurred while fetching campaigns"
      );
    }
  }
);

const fetchClientCompletedCampaignSlice = createSlice({
  name: "campaign",
  initialState: {
    items: [],
    status: "idle",
    error: null,
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchClientCompletedCampaign.pending, (state) => {
        state.status = "loading";
        state.loading = true;
      })
      .addCase(fetchClientCompletedCampaign.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.items = action.payload;
        state.loading = false;
      })
      .addCase(fetchClientCompletedCampaign.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
        state.loading = false;
      });
  },
});

export default fetchClientCompletedCampaignSlice.reducer;
